import { types } from "../../types/types";

export const initialState = {
  datesSchedule: [],
  fullDatesSchedule: new Map(),
};

export const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.fullDatesSchedule:
      const { payload } = action;
      const value = payload.value;
      payload.key = payload.key.replaceAll(" ", "").toLowerCase();
      
      let dataOfCountry = payload.schedules.get(payload.key);

      if (payload.actionDoc !== "removed") {
        if (!dataOfCountry) {
          dataOfCountry = [...value];
        } else {
          if (payload.actionDoc === "added") {
            dataOfCountry.push(...value);
          } else {
            dataOfCountry = [...value];
          }
        }
      } else {
        dataOfCountry = [...value];
      }

      dataOfCountry.sort((a, b) => a["timestamp"] - b["timestamp"]);

      payload.schedules.set(payload.key, dataOfCountry);

      return {
        ...state,
        fullDatesSchedule: payload.schedules,
      };
    default:
      return state;
  }
};
